import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requireOnboarded = true, admin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-[60vh] grid place-items-center text-muted-foreground" data-testid="auth-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  if (requireOnboarded && !user.onboarded && !admin) return <Navigate to="/onboarding" replace />;
  return children;
}
